module.exports = __webpack_public_path__ + "img/follow.44c4fb79.gif";